import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { MosaicCollapsedById } from 'src/components/mosaic/types';
import { ProjectSidebarTileId } from 'src/constants/mosaic';

export const ProjectSidebarToggleContext =
  React.createContext<
    React.Dispatch<
      React.SetStateAction<MosaicCollapsedById<ProjectSidebarTileId>>
    >
  >(noop);

export const useProjectSidebarToggle = () => {
  return React.useContext(ProjectSidebarToggleContext);
};
